export default function ({ $auth, redirect, store }) {
    if ($auth.loggedIn) {
        if (!store?.state?.auth?.user?.is_vendor) redirect('/dashboard')
    } else {
        redirect('/')
    }
}
